import { useMemo } from 'react'
import { Box, Divider, Text } from '@chakra-ui/react'
import { getDevice } from '@!/Util'
import { BorderedGrid } from '@!/components/Grid/BorderedGrid'
import { MenuLink } from '@!/Menu/components'
import { AppStoreBadges } from '@!/Common/AppStoreBadges'
import { XIcon } from '@!/components/Icon'

export const MenuFooterLinks = () => {
  const device = useMemo(() => getDevice(), [])

  const pageLinks = [
    { text: 'マンガBANGブックスTOP', url: '/' },
    { text: '少年・青年マンガ', url: '/store/man' },
    { text: '少女・女性マンガ', url: '/store/woman' },
    { text: 'TLマンガ', url: '/store/tl' },
    { text: 'BLマンガ', url: '/store/bl' },
    { text: 'デイリー人気ランキング', url: '/store/rankings' },
    { text: '注目新刊', url: '/store/new_books' },
    { text: 'おすすめ無料作品一覧', url: '/store/search/free' },
    { text: 'おすすめまとめ買い作品', url: '/store/bulk_purchase_titles' },
    { text: 'ジャンルから探す', url: '/genres' },
  ]

  const freeTitlePageLinks = [
    { text: '少年・青年無料', url: '/store/search/free/man' },
    { text: '少女・女性無料', url: '/store/search/free/woman' },
    { text: 'TL無料', url: '/store/search/free/tl' },
    { text: 'BL無料', url: '/store/search/free/bl' },
  ]

  const enjoyMangaBangLinks = [
    { text: 'マンガBANGマガジン', url: 'https://manga-bang.com/magazine/' },
    { text: 'マンガBANGコミックス', url: 'https://comics.manga-bang.com' },
    { text: 'X（Twitter）', url: 'https://x.com/mangabangfree', icon: XIcon },
  ]

  const footerLinks = [
    { text: '問い合わせ', url: '/inquiry' },
    { text: 'ヘルプ', url: '/static_page/help' },
    { text: 'お知らせ', url: '/announcements' },
  ]

  return (
    <Box>
      <Divider borderBottomWidth={8} borderColor="bg.secondary" />
      <Box borderLeft="solid 3px #E94841" m={6} mb={4}>
        <Text px={3} fontWeight="semibold">
          サイト一覧
        </Text>
      </Box>
      <BorderedGrid columns={2}>
        {pageLinks.map((link, index) => (
          <MenuLink key={`page-${index}`} text={link.text} url={link.url} p={'12px 0'} fontSize={'3xs'} textAlign={'center'} />
        ))}
      </BorderedGrid>
      <Box borderLeft="solid 3px #E94841" m={6} mb={4}>
        <Text px={3} fontWeight="semibold">
          無料作品を探す
        </Text>
      </Box>
      <BorderedGrid columns={2}>
        {freeTitlePageLinks.map((link, index) => (
          <MenuLink key={`free-${index}`} text={link.text} url={link.url} p={'12px 0'} fontSize={'3xs'} textAlign={'center'} />
        ))}
      </BorderedGrid>
      <Box borderLeft="solid 3px #E94841" m={6} mb={4}>
        <Text px={3} fontWeight="semibold">
          マンガBANGをもっと楽しむ
        </Text>
      </Box>
      <BorderedGrid columns={2}>
        {enjoyMangaBangLinks.map((link, index) => (
          <MenuLink key={`enjoy-${index}`} text={link.text} url={link.url} icon={link.icon} isExternal p={'12px 0'} fontSize={'3xs'} textAlign={'center'} />
        ))}
        {/* グリッド数を揃えるための空セル */}
        <Box key="footer-placeholder" />
      </BorderedGrid>
      {device !== 'pc' && (
        <>
          <Box borderLeft="solid 3px #E94841" m={6} mb={4}>
            <Text px={3} fontWeight="semibold">
              アプリのインストールはこちら
            </Text>
          </Box>
          <BorderedGrid columns={1}>
            <AppStoreBadges />
          </BorderedGrid>
        </>
      )}
      <Divider borderBottomWidth={24} borderColor="bg.secondary" />
      <BorderedGrid columns={2}>
        {footerLinks.map((link, index) => (
          <MenuLink key={`footer-${index}`} text={link.text} url={link.url} p={'12px 0'} fontSize={'.6825em'} textAlign={'center'} />
        ))}
      </BorderedGrid>
    </Box>
  )
}
